<template lang="pug">
.new-download
  navigation-bar
  video.video-landscape(autoplay loop muted v-if="isLarge")
    source(src="https://img.loklok.video/fe/1c538669-f670-413a-827d-aef92e25ed78/landscape.mp4" type="video/mp4")
  picture.video-portrait(v-else)
    img(src="https://img.loklok.video/fe/62f1cb18-900e-4964-9749-29d7fbccdf39/bg_1.gif" alt="loklok app download background")
  .info
    img.left(src="https://img.loklok.video/fe/4e8f22f2-5382-4edc-a45a-24b109d5d1db/download_pic_phone.png" alt="loklok app screenshot")
    .right
      .top-wrap
        h2.title Loklok
        p.title Our love lok the world
        p.desc(v-t="'download_nd.desc'")
        img.ercode(src="https://static.loklok.video/img/dwercode220124.png" alt="loklok app download ercode")
        p.tip(v-t="'download_nd.scanQR'")
      .download-btn
        //- a.btn.google(v-show="url.googlePlay" :href="url.googlePlay" target="_blank" @click="onDownload('googlePlay')")
        a.btn.apk(v-show="url.androidApk" :href="url.androidApk" target="_blank" @click="onDownload('apk')")
        //- a.btn.ios(v-show="url.appStore" :href="url.appStore" target="_blank" @click="onDownload('ios')")
        //- a.btn.other-market(v-show="url.androidApk"  :href="url.androidApk" target="_blank" @click="onDownload('other')")
</template>
<script>
import NavigationBar from '../components/navigation-bar'

export default {
  props: ['error'],
  layout: 'default',
  components: {
    NavigationBar
  },
  data() {
    return {
      isLarge: false
    }
  },
  async asyncData({ app, redirect, $ua }) {
    try {
      let res = await app.$api.fetchDownloadLink()
      const seoRes = await app.$api.queryKeyword()
      return {
        url: res,
        seoKeyword: seoRes.keyword
      }
    } catch (error) {
      console.log('detail error:', error)
    }
  },
  head() {
    return {
      title: this.$t('seo.download.title') + '- download loklok',
      meta: [
        { name: 'keywords', content: `${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.download.keywords')}` },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.download.description') + '- loklok'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath('/download_nd') }
      ]
    }
  },
  methods: {
    onDownload(type) {
      this.$buryEvent('下载按钮点击', { type: type })
    }
  },
  mounted() {
    this.isLarge = document.body.offsetWidth >= 750
  }
}
</script>
<style lang="sass" scoped>
@import '../styles/index'
.new-download
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  font-weight: bold
  .info
    height: calc( 100% - 60px )
    padding: 32px 32px 30px 32px
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: center
    img.left
      width: 250px
      margin-right: 150px
    .right
      .title
        margin-bottom: 40px
        font-size: 40px
      h2.title
        font-size: 60px
      .desc
        display: none
        font-size: 12px
      .tip
        margin-top: 14px
        font-size: 16px
      .ercode
        width: 160px
        height: 160px
        border-radius: 16px
        padding: 10px
        background-color: #fff
      .download-btn
        width: 340px
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        .btn
          display: block
          width: 160px
          height: 45px
          background: url('https://static.loklok.video/img/下载按钮.png') no-repeat
          background-size: cover
          margin-top: 20px
        .apk
          background-position: left top
        .google
          background-position: left -45px
        .ios
          background-position: left -90px
        .other-market
          background-position: left bottom
video,picture,picture>img
  position: fixed
  right: 0px
  bottom: 0px
  min-width: 100%
  min-height: 100%
  height: auto
  width: auto
  z-index:-11
source
  min-width: 100%
  min-height: 100%
  height: auto
  width: auto
.video-portrait
  display: none
@media screen and (max-width: 960px)
  .video-portrait
    display: none
@media screen and (max-width: 750px)
  .new-download
    .nav-bar
      background-color: rgba(0,0,0,0)

    .video-landscape,.left,.ercode,.tip
      display: none
    .video-portrait,.info .right .desc
      display: block
    .info .right .download-btn
      width: 332px
      .btn
        margin-top: 30px
    .info .right
      height: 100%
      display: flex
      flex-wrap: wrap
      flex-direction: column
      //justify-content: space-between
      justify-content: flex-start
      .title
        font-size: 20px
        margin-bottom: 12px
      h2.title
        font-size: 32px
</style>
